const IconPlusLogo = () => (
  <svg
    width="154"
    height="24"
    viewBox="0 0 154 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_8662_63711)">
      <path
        d="M28.1119 5.73692L22.4154 19.0816L20.7898 7.49088C20.5831 5.91232 23.1996 4.94764 23.1996 4.94764C22.9572 4.40684 22.1373 4.41415 22.1373 4.41415H20.3692C20.0911 1.56396 22.615 -0.511554 25.3385 0.116948C28.0193 0.730833 28.9889 3.71987 28.1191 5.74423L28.1119 5.73692Z"
        fill="white"
      />
      <path
        d="M17.5317 23.3935L6.42374 15.8076C3.59328 13.8709 0.798465 15.8441 0.206706 17.8831C-0.670239 20.8868 1.29041 23.3935 4.36328 23.3935H17.5317Z"
        fill="white"
      />
      <path
        d="M18.986 4.58945C19.3995 1.64426 16.8257 -0.533569 14.038 0.109549C11.3573 0.723435 10.3876 3.71247 11.2575 5.73683L16.954 19.0815L18.986 4.58945Z"
        fill="white"
      />
      <path
        d="M16.4979 21.2668L11.0294 8.49214C9.74611 5.53233 6.35954 5.15962 4.48444 6.89896C3.16546 8.12673 2.1388 11.4593 5.09046 13.4763L16.4979 21.2668Z"
        fill="white"
      />
      <path
        d="M35.0063 23.3935C38.0792 23.3935 40.0327 20.8868 39.1629 17.8831C38.5711 15.8441 35.7763 13.8709 32.9459 15.8076L21.8379 23.3935H35.0063Z"
        fill="white"
      />
      <path
        d="M34.2795 13.4763C37.2311 11.4593 36.2045 8.12673 34.8855 6.89896C33.0104 5.15962 29.6238 5.53233 28.3405 8.49214L22.8721 21.2668L34.2795 13.4763Z"
        fill="white"
      />
      <path
        d="M67.0469 0.599365H72.2586L83.003 15.3399V0.599365H87.8868V23.3935H82.675L71.9307 8.62373V23.3935H67.0469V0.599365Z"
        fill="white"
      />
      <path
        d="M112.777 16.2169C112.777 22.4215 107.928 23.3935 104.906 23.3935H91.9795V0.599365H104.891C108.855 0.599365 112.014 2.90144 112.014 7.22056C112.014 9.36185 110.545 10.5385 109.426 11.1231C111.265 12.0659 112.769 13.4617 112.769 16.2169H112.777ZM96.6922 4.87464V9.18645H104.314C105.569 9.18645 106.952 8.64565 106.952 7.04516C106.952 5.44468 105.875 4.87464 104.136 4.87464H96.6922ZM107.75 16.2169C107.75 14.0318 105.975 13.4617 104.242 13.4617H96.6993V18.9063H104.421C105.832 18.9063 107.75 18.402 107.75 16.2169Z"
        fill="white"
      />
      <path
        d="M137.424 19.6809C134.985 21.8222 132.355 24 127.157 24C120.248 23.9708 114.894 18.4823 114.894 11.9562C114.93 5.22534 120.505 0 127.221 0C133.053 0 136.19 3.82948 136.597 4.25335L132.925 8.01705C132.126 7.18392 130.401 5.29111 127.186 5.29111C123.278 5.29111 120.099 8.28745 120.099 11.9781C120.099 15.1937 122.801 18.665 127.157 18.665C130.636 18.665 131.92 17.4957 134.058 15.6541L137.424 19.6736V19.6809Z"
        fill="white"
      />
      <path
        d="M64.8084 19.6809C62.3701 21.8222 59.7393 24 54.5418 24C47.6332 23.9708 42.2788 18.4823 42.2788 11.9562C42.3145 5.22534 47.8898 0 54.6059 0C60.438 0 63.575 3.82948 63.9814 4.25335L60.3096 8.01705C59.5111 7.18392 57.7858 5.29111 54.5703 5.29111C50.6633 5.29111 47.4834 8.28745 47.4834 11.9781C47.4834 15.1937 50.1856 18.665 54.5418 18.665C58.021 18.665 59.3044 17.4957 61.4433 15.6541L64.8084 19.6736V19.6809Z"
        fill="white"
      />
      <path
        d="M154 9.45683H148.924V4.25342H144.033V9.45683H138.949V14.4702H144.033V19.6809H148.924V14.4702H154V9.45683Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_8662_63711">
        <rect width="154" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default IconPlusLogo;
